import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { useTranslate } from 'react-admin';
import { PeriodPreset } from '../../../utils/dashboard/periodRange';

const PRESETS: PeriodPreset[] = ['lastWeek', 'lastMonth', 'lastYear'];

interface PeriodPresetMenuProps {
    onSelect: (preset: PeriodPreset) => void;
}

const PeriodPresetMenu: React.FC<PeriodPresetMenuProps> = ({ onSelect }) => {
    const translate = useTranslate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleSelect = (preset: PeriodPreset) => {
        onSelect(preset);
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                color='primary'
                data-testid='period-preset-trigger'
                onClick={(event) => setAnchorEl(event.currentTarget)}
            >
                <DateRangeIcon style={{ marginRight: 5, fontSize: 20 }} />
                {translate('app.dashboard.period.menu')}
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} keepMounted>
                {PRESETS.map((preset) => (
                    <MenuItem key={preset} data-testid={`period-${preset}`} onClick={() => handleSelect(preset)}>
                        {translate(`app.dashboard.period.${preset}`)}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default PeriodPresetMenu;
